/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { BuilderFormSchemaFactory, FormRootSchema, FormStateSchema } from '@gh/builder-shared';
import {
  FormState,
  whenEditMode,
} from '@gh/common-shared';
import {
  FormMode,
} from '@gh/core-ui';
import { PbBulkUpdateHPMarkup } from '../../resources/pb-bulk-update-markup.model';

@Injectable()
export class PbBulkUpdateHpMarkupFormState extends FormState<PbBulkUpdateHPMarkup> {
  private basicInfo: PbBulkUpdateHPMarkup;

  constructor(private schemaFactory: BuilderFormSchemaFactory,
              ) {
    super(schemaFactory);
  }

  buildSchema(info: PbBulkUpdateHPMarkup, { root }: FormStateSchema): FormRootSchema {
    const mode = FormMode.EditMode;
    return root({
      mode,
      enabled: whenEditMode(),
      optimisticLock: true,
      children: {
        overhead: void 0,
        contingency: void 0,
        profit: void 0,
        total: {enabled: false},
        qqMarkup: void 0,
      },
    });
  }

  build(basicInfo: PbBulkUpdateHPMarkup): void {
    this.basicInfo = basicInfo;

    this.initSchema(basicInfo);
  }
}
